import { render, staticRenderFns } from "./HelpSection.vue?vue&type=template&id=f18144a6&"
import script from "./HelpSection.vue?vue&type=script&lang=js&"
export * from "./HelpSection.vue?vue&type=script&lang=js&"
import style0 from "./HelpSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports